import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { BreakConfigurationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  breakConfiguration: BreakConfigurationFragment
}

const ArchivedItem = ({ breakConfiguration }: Props) => {
  const { name, paid } = breakConfiguration

  const paidTypeCopy = paid ? i18n.t('break_types.paid') : i18n.t('break_types.unpaid')

  return (
    <Box flexDirection="row" gap="s16" alignItems="flexStart" justifyContent="spaceBetween">
      <Box>
        <Text size="300" color="grey800" weight="medium" ellipsis>
          {name}
        </Text>
      </Box>
      <Box justifyContent="flexEnd">
        <Text size="300" color="grey800" weight="medium">
          {paidTypeCopy}
        </Text>
      </Box>
    </Box>
  )
}

export default observer(ArchivedItem)
